import React from "react";
import {
  FaCode,
  FaShoppingCart,
  FaRobot,
  FaChartLine,
  FaGlobe,
  FaBolt
} from "react-icons/fa";

const services = [
  {
    icon: <FaCode size={40} />,
    title: "Desarrollo Web",
    description:
      "Sitios rápidos y responsivos con React, Next.js y tecnologías modernas."
  },
  {
    icon: <FaGlobe size={40} />,
    title: "CMS y Contenidos",
    description:
      "WordPress, Elementor y Avada para gestionar tu web de forma simple."
  },
  {
    icon: <FaShoppingCart size={40} />,
    title: "E-Commerce",
    description:
      "Tiendas online con WooCommerce y PrestaShop optimizadas para vender."
  },
  {
    icon: <FaRobot size={40} />,
    title: "Inteligencia Artificial",
    description:
      "Chatbots y automatización para mejorar tu negocio."
  },
  {
    icon: <FaChartLine size={40} />,
    title: "Marketing Digital",
    description:
      "SEO, Ads y estrategias para generar clientes y ventas."
  },
  {
    icon: <FaBolt size={40} />,
    title: "Optimización Web",
    description:
      "Velocidad, SEO técnico y rendimiento."
  }
];

export default function Services() {
  return (
    <section className="services-section text-center">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4 col-sm-6">
              <div className="service-card">
                <div className="icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}